export default __webpack_public_path__ + "static/media/logo1_black.b8d0fb41.png";